var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFosterLogoNavMobile = function SvgFosterLogoNavMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "logo-text-01",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.401,
    height: 22.781
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54184"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68807",
    d: "M2.71 1.167H0v14.744h2.71v-5.606h7.565V7.758H2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68808",
    d: "M3.959 3.879h7.9V1.167H4.882Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68809",
    d: "M42.872 7.008c-1.866-.532-3.591-.935-4.214-1.745l-2.708.778c.55 1.446 1.91 2.244 3.6 2.737 1.784.518 5.4 1.334 5.4 2.735 0 1.213-1.634 1.852-3.175 1.852a10.111 10.111 0 0 1-4.811-1.423l-1.273 2.238a12.415 12.415 0 0 0 6.088 1.731c3.629 0 5.9-1.73 5.9-4.4-.006-2.634-2.576-3.869-4.807-4.503Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68810",
    d: "M41.391 2.93a10.342 10.342 0 0 1 4.636 1.259l1.108-2.241A12.142 12.142 0 0 0 41.39.462c-3.115 0-4.722 1.273-5.362 2.6l2.674.765a3.853 3.853 0 0 1 2.689-.897Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68811",
    d: "M57.527 15.91h2.709V4.904l-2.709.923Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1843",
    d: "M52.367 1.167h13.029v2.547H52.367z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68812",
    d: "M74.105 3.714h7.843V1.167h-6.976Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68813",
    d: "M72.799 9.812h7.566V7.265h-7.566v-6.1h-2.71v14.746h11.859v-2.548h-9.149Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68814",
    d: "M96.619 10.861a5.093 5.093 0 0 0-2.236-9.693H91.51l-.895 2.63h3.688a2.472 2.472 0 1 1 0 4.943h-4.95V1.167h-2.708v14.744h2.708v-4.542h4.448l3.4 4.542h3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68815",
    d: "m36.215 19.62-1.379 1.839h-.157l-1.348-1.845v3.079h-.8v-4.237h.919l1.322 1.821 1.322-1.821h.918v4.23h-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68816",
    d: "M43.066 21.886h-2.215l-.359.8h-.868l1.9-4.234h.871l1.9 4.234h-.87Zm-1.108-2.544-.786 1.8h1.572Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68817",
    d: "M50.701 22.681h-.95l-1.234-1.412h-.765v1.412h-.8v-4.237c.672 0 1.343.006 2.014.006a1.4 1.4 0 0 1 1.524 1.4 1.256 1.256 0 0 1-1.071 1.33l1.282 1.445Zm-2.951-3.489v1.352h1.216a.679.679 0 1 0 0-1.355Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68818",
    d: "m56.721 18.469-1.878 2.026 2.038 2.135v.046h-.988l-1.772-1.874v1.874h-.8v-4.227h.8v1.791l1.608-1.791h.992Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68819",
    d: "M62.736 22.68h-3.169v-4.231h3.169v.774h-2.377v.974h2.292v.744h-2.292v.956h2.377Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68820",
    d: "M66.991 19.175h-1.343v-.726h3.484v.726h-1.343v3.505h-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68821",
    d: "M73.907 21.438h-1.2v1.243h-.8V18.45c.665 0 1.33-.006 2-.006a1.5 1.5 0 1 1 0 2.994Zm-1.2-.732h1.2a.75.75 0 1 0 0-1.5h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68822",
    d: "M79.093 18.449v3.5h2.178v.735h-2.976v-4.235Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68823",
    d: "M87.135 21.886h-2.213l-.363.8h-.862l1.9-4.234h.87l1.9 4.234h-.871Zm-1.106-2.546-.786 1.8h1.572Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68824",
    d: "M94.498 22.151a2.231 2.231 0 0 1-1.609.63 2.082 2.082 0 0 1-2.244-2.184 2.132 2.132 0 0 1 2.244-2.229 2.187 2.187 0 0 1 1.555.647l-.532.514a1.456 1.456 0 0 0-1.023-.4 1.394 1.394 0 0 0-1.461 1.469 1.352 1.352 0 0 0 1.461 1.433 1.557 1.557 0 0 0 1.064-.429Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68825",
    d: "M100.399 22.68H97.23v-4.231h3.169v.774H98.02v.974h2.292v.744H98.02v.956h2.377Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68826",
    d: "M20.215 16.343a.982.982 0 0 1 .194-.513c-1.086-1.414-4.3-4.876-5.6-9.286-.002 0-2.727 4.072 5.406 9.799Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68827",
    d: "M21.435 15.167c-4.494-9.926-2.9-13.44-2.9-13.44-.945.079-3.27 1.629-3.12 3.76.254 3.657 4.058 8.6 5.26 10.074a2.584 2.584 0 0 1 .76-.394Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68828",
    d: "M23.068 14.914c.1 0 .193 0 .289.007.224-3.256.639-11.325.417-13.559-.236-2.366-3.843-1.211-4.394.157-1.558 3.87 1.531 11.5 2.42 13.539a5.465 5.465 0 0 1 1.268-.144Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68829",
    d: "M23.735 14.954a4.868 4.868 0 0 1 .789.155c1.855-3.717 3.376-8.589 3.087-11.855A3.028 3.028 0 0 0 24.437.495c.414 4.176-.44 12.181-.702 14.459Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68830",
    d: "M28.312 2.808c.464 4.688-2.426 10.678-3.353 12.457a2.106 2.106 0 0 1 .626.4c1.822-2.587 4.249-5.459 4.889-8.906a3.621 3.621 0 0 0-2.162-3.951Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68831",
    d: "M31.03 6.544c-.262 3.4-3.8 7.755-5.233 9.392a.951.951 0 0 1 .1.25c8.759-5.316 5.133-9.642 5.133-9.642Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68832",
    d: "M23.068 15.325c-1.352 0-2.448.487-2.448 1.092a2.747 2.747 0 0 0 .189 1.073 2.222 2.222 0 0 0 .144.319.809.809 0 0 1 .128-.168 1.547 1.547 0 0 1 .494-.312 3.948 3.948 0 0 1 1.494-.264 4.322 4.322 0 0 1 1.174.152 1.9 1.9 0 0 1 .814.423.829.829 0 0 1 .13.17 2.278 2.278 0 0 0 .143-.319 2.754 2.754 0 0 0 .189-1.073c-.002-.604-1.098-1.093-2.451-1.093Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68833",
    d: "M23.087 17.399c-1.037 0-1.878.249-1.878.557s.841.557 1.878.557 1.879-.249 1.879-.557-.842-.557-1.879-.557Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68834",
    d: "M23.594 19.265a11.957 11.957 0 0 0-1.531-.43c-.161-.017-.425.021-.425.337s.264 1.071 1.716 1.037c.619-.014.969-.157 1.051-.348s-.059-.282-.811-.596Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68835",
    d: "m22.809 18.904 1.373.45s.332.1.417-.116.1-.452-.259-.475-2.378-.137-1.531.141Z",
    "data-fill": "a"
  }))));
};
export default SvgFosterLogoNavMobile;